export const dateRegexp = /^\d\d.\d\d$/;
